import { createContext, useEffect, useState } from "react";

import useLocalStorage from "../hooks/useLocalStorage";

const ClinicContext = createContext({
  clinicId: "",
  clinicName: "",
  clinicTimezone: null,
  clinicLang: "",
  clinicLicensing: {
    canVideoStream: false,
    canUseDicomReports: false,
    canUsePngReports: false,
    canDisplayTotalAndPatternDeviationNumericalCharts: false,
    canUseBaileyLovieExams: false,
    canUseExamPackaging: false,
    canUseSynoptophoreExams: false,
    canUseRAPDExams: false,
  },
  clinicSettings: {
    id: "",
    clinicDefaultLanguage: "",
    patientDefaultLanguage: "",
    colorVisionDefaultTimeLimit: 0,
    lastModifiedDate: "",
    lastModifiedBy: "",
    reportDisplayLeftEyeFirst: true, // default value is true
  },
  patientDefaultLang: "",
  allClinicInfo: [],
  setClinicId: () => {},
  setClinicName: () => {},
  setClinicTimezone: () => {},
  setClinicLang: () => {},
  setClinicLicensing: () => {},
  setClinicSettings: () => {},
  setPatientDefaultLang: () => {},
  setAllClinicInfo: () => {},
});

const ClinicProvider = ({ children }) => {
  const [clinicId, setClinicId] = useLocalStorage("clinicId", "");
  const [clinicName, setClinicName] = useLocalStorage("clinicName", "");
  const [clinicTimezone, setClinicTimezone] = useLocalStorage(
    "clinicTimezone",
    null
  );
  const [allClinicInfo, setAllClinicInfo] = useLocalStorage("allClinics", []);
  const [selectedPatient, setSelectedPatient] = useLocalStorage(
    "selectedPatient",
    []
  );
  const [clinicSettings, setClinicSettings] = useLocalStorage(
    "clinicSettings",
    {}
  );
  const [clinicLang, setClinicLang] = useState(null);
  const [clinicLicensing, setClinicLicensing] = useState({});
  const [patientDefaultLang, setPatientDefaultLang] = useState(null);

  useEffect(() => {
    if (clinicId) {
      const clinicExists = allClinicInfo.some(
        (clinic) => clinic.id === clinicId
      );
      if (!clinicExists) {
        setClinicId("");
        setClinicName("");
        setClinicTimezone(null);
        setClinicLang(null);
        setClinicLicensing({});
        setClinicSettings({});
      }
    }
  }, [
    clinicId,
    allClinicInfo,
    setClinicId,
    setClinicName,
    setClinicTimezone,
    setClinicSettings,
  ]);

  return (
    <ClinicContext.Provider
      value={{
        clinicId,
        clinicName,
        clinicTimezone,
        clinicLang,
        clinicLicensing,
        clinicSettings,
        patientDefaultLang,
        allClinicInfo,
        setClinicId,
        setClinicName,
        setAllClinicInfo,
        selectedPatient,
        setSelectedPatient,
        setClinicTimezone,
        setClinicLang,
        setClinicLicensing,
        setClinicSettings,
        setPatientDefaultLang,
      }}
    >
      {children}
    </ClinicContext.Provider>
  );
};

export { ClinicContext, ClinicProvider };
